import React from "react";

import UiDialog from "components/Custom/UiDialog";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";

import { FORMATS } from "common/config";
import { LABELS } from "common/labels";
import { DateFunctions } from "common/datefunctions";
import { ApiIndents } from "apihandlers/indent";

const API_HANDLER_INDENT = new ApiIndents();

const FutureView = (props: any) => {
  const {
    showVehicles,
    setShowVehicles,
    setFutureVehicle,
    setFutureViewVehicles,
  } = props;

  const getVehicleLocation = () => {
    setShowVehicles(false);
    setFutureVehicle(true);
    const dateTime = (document.getElementById("futureDt") as HTMLInputElement)
      .value;
    const dt = dateTime.replace("T", " ");
    const args = { dt };
    API_HANDLER_INDENT.getVehicleOnMap(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let records = Object.values(response);
        records = records.map((rec: any, i) => {
          return {
            ...rec,
            lat: parseFloat(rec.latitude),
            lng: parseFloat(rec.longitude),
          };
        });
        setFutureViewVehicles(records);
      }
    });
  };

  return (
    <>
      {showVehicles && (
        <UiDialog
          title={LABELS.FUTURE_VIEW}
          open={true}
          size={"xs"}
          onClose={() => {
            setShowVehicles(!showVehicles);
          }}
        >
          <div className="formGroup width" style={{ marginTop: "-20px" }}>
            <label>{LABELS.SELECT_DATE_TIME}</label>
            <TxtBox
              type={"datetime-local"}
              id="futureDt"
              defaultValue={DateFunctions.getFormatedDate(
                new Date(),
                FORMATS.SQL_DATE,
                FORMATS.SQL_DATE
              )}
            />
          </div>

          <div className="formGroup flexRowJustify">
            <div className="formGroup  "> </div>
            <Btn
              className="formGroup"
              text={LABELS.LOAD}
              onClick={getVehicleLocation}
            />
            <div className="formGroup"> </div>
          </div>
        </UiDialog>
      )}
    </>
  );
};

export default FutureView;
